@charset "UTF-8";

/* app/js/src/components/clipping-studio/panels/text-panel/clipping-studio-text-panel.component.scss */
.cursor-pointer {
  cursor: pointer;
}
.text-panel__content::-webkit-scrollbar {
  height: 11px;
  overflow: visible;
  width: 11px;
  opacity: 1;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
.text-panel__content::-webkit-scrollbar-button {
  height: 0;
  width: 0;
}
.text-panel__content::-webkit-scrollbar-corner {
  background: transparent;
}
.text-panel__content::-webkit-scrollbar-thumb:hover {
  background-color: #b9bec9;
}
.text-panel__content::-webkit-scrollbar-thumb {
  background-color: #e3e6ea;
  background-clip: padding-box;
  border: solid transparent;
  border-width: 0 4px 0 4px;
  min-height: 28px;
  padding: 100px 0 0;
  border-radius: 10px;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
.text-panel__content::-webkit-scrollbar-thumb:hover {
  background-color: #b9bec9;
}
.text-panel__content::-webkit-scrollbar-track:hover {
  background-color: #eef2f6;
}
.text-panel__content::-webkit-scrollbar-track {
  background-clip: padding-box;
  border: solid transparent;
  border-width: 0 4px 0 4px;
}
.text-panel {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
  font-family: "Open Sans", sans-serif;
  position: relative;
}
.text-panel__content {
  flex: 1;
  overflow-y: auto;
  padding: 14px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.text-panel__section-title {
  font-size: 11px;
  font-weight: 900;
  color: rgba(0, 0, 0, 0.85);
  text-transform: uppercase;
  letter-spacing: 0.1em;
  margin: 0;
}
.text-panel__message {
  font-size: 14px;
  color: rgba(0, 0, 0, 0.54);
  margin: 0;
}
.text-panel__section {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.text-panel__error {
  padding: 12px 0;
}
.text-panel__error-text {
  margin: 0;
  font-size: 14px;
  color: #ef5350;
}
.text-panel__basic-section {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.text-panel__add-btn {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 12px 14px;
  background: rgb(255, 255, 255);
  border: 1px solid rgb(226, 232, 241);
  border-radius: 6px;
  cursor: pointer;
  transition: border-color 0.15s ease;
}
.text-panel__add-btn:hover {
  border-color: rgba(22, 177, 255, 0.5);
}
.text-panel__add-btn-text {
  font-size: 14px;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.85);
  font-family: "Open Sans", sans-serif;
}
.text-panel__add-btn-text--heading {
  font-size: 18px;
  font-weight: 900;
}
.text-panel__add-icon {
  font-size: 18px;
  font-weight: 700;
  color: rgba(0, 0, 0, 0.54);
  transition: color 0.15s ease;
}
.text-panel__add-btn:hover .text-panel__add-icon {
  color: #40c4ff;
}
.text-panel__grid {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  gap: 12px;
}
.text-panel__grid > * {
  min-width: 0;
}
/*# sourceMappingURL=clipping-studio-text-panel.component.css.map */
